import { render } from "./ViewAllBrands.vue?vue&type=template&id=11aa7693"
import script from "./ViewAllBrands.vue?vue&type=script&lang=js"
export * from "./ViewAllBrands.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__